// One-click PNG of the decal-on-vehicle mock-up: the live SVG is serialised with the vehicle picture inlined, rasterised at 1600 px
// wide on the workspace background, captioned, and downloaded (or shared via the Web Share API when the browser offers it).
const toDataUrl = async (url) => {
  const r0 = await fetch(url);
  if (!r0.ok) throw new Error(`fetch ${r0.status}`);
  const blob = await r0.blob();
  return new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(blob); });
};

export async function exportMockup(svgEl, { len, floorY, caption, filename }) {
  const clone = svgEl.cloneNode(true);
  clone.querySelectorAll(".pv-ui").forEach((n) => n.remove());
  clone.querySelectorAll(".pv-ui-stroke").forEach((n) => n.setAttribute("stroke", "none"));
  const cache = {};
  for (const im of clone.querySelectorAll("image, feImage")) {
    const href = im.getAttribute("href");
    try { cache[href] = cache[href] || (await toDataUrl(href)); im.setAttribute("href", cache[href]); } catch (e) { im.remove(); }
    im.removeAttribute("data-testid");
  }
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
  // 16:9 showroom framing: whole vehicle with studio space around it, floor below
  const fw = len * 1.12, fh = (fw * 9) / 16;
  clone.setAttribute("viewBox", `${-(fw - len) / 2} ${floorY / 2 - fh * 0.47} ${fw} ${fh}`);
  const W = 1600, Hpx = Math.round((W * fh) / fw), FOOT = 56;
  clone.setAttribute("width", W); clone.setAttribute("height", Hpx);
  clone.removeAttribute("class"); clone.removeAttribute("style");
  const svgUrl = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: "image/svg+xml;charset=utf-8" }));
  try {
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => rej(new Error("render failed")); i.src = svgUrl; });
    const c = document.createElement("canvas"); c.width = W; c.height = Hpx + FOOT;
    const ctx = c.getContext("2d");
    const g = ctx.createLinearGradient(0, 0, 0, Hpx); g.addColorStop(0, "#121824"); g.addColorStop(0.6, "#0f141f"); g.addColorStop(1, "#0b0f17");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, Hpx);
    ctx.drawImage(img, 0, 0, W, Hpx);
    ctx.fillStyle = "#121824"; ctx.fillRect(0, Hpx, W, FOOT);
    ctx.fillStyle = "#e8e9ec"; ctx.font = "600 20px 'IBM Plex Sans', Arial, sans-serif"; ctx.textBaseline = "middle"; ctx.fillText(caption, 24, Hpx + FOOT / 2);
    ctx.fillStyle = "#9aa0a8"; ctx.font = "16px 'IBM Plex Sans', Arial, sans-serif"; ctx.textAlign = "right"; ctx.fillText("Mock-up · sizes approximate · made with Xpattern", W - 24, Hpx + FOOT / 2);
    const blob = await new Promise((res) => c.toBlob(res, "image/png"));
    const file = new File([blob], filename, { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) {
      try { await navigator.share({ files: [file], title: caption }); return "shared"; } catch (e) { if (e?.name === "AbortError") return "cancelled"; }
    }
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = filename; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    return "downloaded";
  } finally { URL.revokeObjectURL(svgUrl); }
}
